import clx from 'classnames';
import { darken } from 'polished';
import React from 'react';
import styled from 'styled-components';

const AiMessageSpan = styled.span`
  color: ${props => darken(0.1, props.theme.colorInfoActive)};
  &.success {
    color: ${props => props.theme.colorSuccessActive};
  }
`;

export interface IAiMessageTextProps {
  icon?: React.ReactNode;
  warningText: string;
  successText?: string;
  success?: boolean;
  isBackoffice?: boolean;
}
/**
 * Messaggio di verifica AI con icona e testo di successo o warning
 */
export function AiMessageText(props: IAiMessageTextProps) {
  const { icon, success, warningText, successText, isBackoffice } = props;

  return (
    <AiMessageSpan
      className={clx({
        success: success,
      })}
    >
      {isBackoffice && icon} {success ? successText : warningText}{' '}
    </AiMessageSpan>
  );
}
